/**
 * @file WordPressPublishButton.tsx
 * @description Button component for publishing content to WordPress.
 * Supports different style variants and loading states.
 */

import React from "react";

type ButtonVariant = "primary" | "success" | "outline-white";

interface WordPressPublishButtonProps {
  onPublish: () => Promise<void>;
  isLoading?: boolean;
  disabled?: boolean;
  variant?: ButtonVariant;
  className?: string;
}

const variantStyles: Record<ButtonVariant, string> = {
  primary: "px-6 text-base rounded-full btn btn-primary",
  success:
    "px-6 text-base border-none rounded-full text-primary-content btn btn-success",
  "outline-white":
    "text-lg text-white border-white rounded-full btn btn-outline hover:text-primary hover:bg-white hover:border-white",
};

const WordPressPublishButton: React.FC<WordPressPublishButtonProps> = ({
  onPublish,
  isLoading = false,
  disabled = false,
  variant = "primary",
  className = "",
}) => {
  const handlePublish = async () => {
    try {
      await onPublish();
    } catch (error) {
      // Error handling is done in the parent component/service
    }
  };

  return (
    <button
      className={`${variantStyles[variant]} ${className}`}
      disabled={disabled || isLoading}
      onClick={handlePublish}
    >
      {isLoading ? (
        <span className="loading loading-spinner"></span>
      ) : (
        "Invia a WordPress"
      )}
    </button>
  );
};

export default WordPressPublishButton;
